import {Button} from "@mui/material";
import {Box} from "@mui/system";
import {FC} from "react";
import {UserClimbingEvent} from "../../../../models/UserClimbingEvent";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router";

type Props = {
  userEvent: UserClimbingEvent
}

export const SimplifiedResultsComponent: FC<Props> = ({userEvent}) => {
  const {t} = useTranslation()
  const navigate = useNavigate()

  const getResultsLink = () => {
    const difficulty = userEvent.category ? `&difficulty=${userEvent.category}` : ""
    return `/results?eventId=${userEvent.eventId}${difficulty}`
  }

  return (
    <Box display="flex" m={2} alignItems="center" flexDirection="column">
      <Button color={"primary"} variant={"contained"}
              onClick={() => navigate(getResultsLink())}>{t('event.fullResults')}</Button>
    </Box>
  )
}